import { render, staticRenderFns } from "./EditCertificate.vue?vue&type=template&id=2ca4b86e&"
import script from "./EditCertificate.vue?vue&type=script&lang=js&"
export * from "./EditCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports